import type { RouteComponentProps } from '@reach/router';
import React from 'react';
import { withErrorBoundary } from 'react-error-boundary';
import { defineMessages, useIntl } from 'react-intl';

import { ErrorBoundaryFallback } from '@components/ErrorBoundaryFallback';

import { useGetLatestObservations } from '@hooks/api/observation';

import { TrackerType } from '@models/vital-sign';

import HealthTrackerMain from '@views/Records/HealthTracker/Main';

const messages = defineMessages({
  title: {
    id: 'fitnessMain.title',
    defaultMessage: 'Fitness',
  },
});

const FitnessMain: React.FC<RouteComponentProps> = () => {
  const { formatMessage } = useIntl();

  const {
    data: {
      distance,
      steps,
      fitness_average_heart_rate,
      resting_heart_rate,
      energy_burned,
    },
    loading,
  } = useGetLatestObservations({
    distance: true,
    steps: true,
    fitness_average_heart_rate: true,
    resting_heart_rate: true,
    energy_burned: true,
  });

  const records = {
    distance,
    steps,
    average_heart_rate: fitness_average_heart_rate,
    resting_heart_rate,
    energy_burned,
  };

  return (
    <HealthTrackerMain
      category={TrackerType.Fitness}
      loading={loading}
      records={records}
      title={formatMessage(messages.title)}
    />
  );
};

export default withErrorBoundary(FitnessMain, {
  FallbackComponent: ErrorBoundaryFallback,
});
